<div class="pdf-viewer-container" [style.width]="width" [style.height]="height">
  <div *ngIf="errorMessage" class="pdf-error-message" style="color: red; text-align: center; margin-bottom: 1rem;">
    {{ errorMessage }}
  </div>
  <div *ngIf="!errorMessage">
    <div class="pdf-extra-controls" *ngIf="canPrint || canDownload || canZoom"
      style="display: flex; gap: 8px; justify-content: flex-end; margin-bottom: 1rem;">
      <button *ngIf="canPrint" (click)="printPDF()" class="control-btn">Print</button>
      <button *ngIf="canDownload" (click)="downloadPDF()" class="control-btn">Download</button>
      <button *ngIf="canZoom" (click)="zoomIn()" class="control-btn">Zoom In</button>
      <button *ngIf="canZoom" (click)="zoomOut()" class="control-btn">Zoom Out</button>
    </div>
    <div #pdfContainer class="pdf-container pdf-scroll-container" [style.maxHeight]="containerHeight"
      style="overflow-y: auto;"></div>
  </div>
</div>
